import type { FluxErrorEntityErrorCodes } from '../types.js';

export const AttachmentErrorCodes = {
  AttachmentFileSizeExceeded: {
    code: 'attachment/file-size-exceeded',
    message: 'O tamanho do arquivo excede o limite permitido. Reduza o tamanho do arquivo ou comprima-o antes de tentar novamente.',
    explanation: 'O arquivo que você tentou enviar é maior que o tamanho máximo permitido pelo sistema. Cada tipo de arquivo pode ter um limite diferente.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Aba de Anexos',
        path: '/wiki/docs/cards/tabs/attachments',
      },
    ],
  },
  AttachmentInvalidFileExtension: {
    code: 'attachment/invalid-file-extension',
    message: 'O formato do arquivo não é aceito. Verifique a extensão e tente novamente.',
    explanation: 'A extensão do arquivo que você tentou enviar não é permitida. Verifique os formatos de arquivo aceitos.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Aba de Anexos',
        path: '/wiki/docs/cards/tabs/attachments',
      },
    ],
  },
  AttachmentNotFound: {
    code: 'attachment/not-found',
    message: 'O anexo solicitado não foi encontrado.',
    explanation: 'O anexo que você está tentando acessar não foi encontrado no sistema. Ele pode ter sido removido pelo autor ou o link pode estar incorreto.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Aba de Anexos',
        path: '/wiki/docs/cards/tabs/attachments',
      },
    ],
  },
} as const satisfies FluxErrorEntityErrorCodes<'attachment'>;
